import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeedbackComponent } from './feedback.component';
import { MatIconModule } from '@angular/material/icon';
import { AvatarModule } from '../avatar';
import { ButtonModule } from '../button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormFieldModule } from '../form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from '@lockton-apps/material';
import { FormGroupValidationDirective } from '@lockton-apps/shared/util/form-utils';

@NgModule({
  declarations: [FeedbackComponent],
  imports: [
    CommonModule,
    AvatarModule,
    MatIconModule,
    ButtonModule,
    FormsModule,
    FormFieldModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MaterialModule,
    FormGroupValidationDirective,
  ],
  exports: [FeedbackComponent],
})
export class FeedbackModule {}
